import { css } from '@emotion/core'
import { indexOf, keys, sortBy } from 'lodash'

export const fontFace = (
  name,
  files = {},
  weight = 'normal',
  style = 'normal'
) => {
  return css`
		@font-face {
			font-family: ${name};
			${fontFaceSrc(files, name)}
			font-weight: ${weight};
			font-style: ${style};
		}
	`
}

const fontFaceSrc = (files = {}, name = null) => css`
  ${files.eot ? css`src: url('${files.eot}');` : null}
  ${files && keys(files).length > 0
    ? css`
        src: ${orderFontFaceKeys(keys(files))
          .map((_key, _i) => {
            const _format = fontFaceFormat(_key)

            return `url('${files[_key]}${
              _key === 'eot' ? `#iefix` : _key === 'svg' ? `#${name}` : ``
            }')${_format ? ` format('${_format}')` : ``}`
          })
          .join(',')};
      `
    : null}
`

const fontFaceFormat = type => {
  switch (type) {
    case 'eot':
      return 'embedded-opentype'
    case 'ttf':
      return 'truetype'
    case 'svg':
    case 'woff2':
    case 'woff':
      return type
    default:
      return null
  }
}

const orderFontFaceKeys = keys => {
  const order = ['eot', 'woff2', 'woff', 'ttf']
  return sortBy(keys, (_k) => {
    return indexOf(order, _k)
  })
}